export interface NormalizedPermissions {
    codes: Set<string>;
    isFullAdmin: boolean;
}

export const initialNormalizedPermissions: NormalizedPermissions = {
    codes: new Set(),
    isFullAdmin: false,
};

interface MyPermissionsResponse {
    user_id: number;
    email: string;
    permission_codes: string[];
    has_full_admin: boolean;
}

export function normalizePermissions(response: MyPermissionsResponse): NormalizedPermissions {
    return {
        codes: new Set(response.permission_codes ?? []),
        isFullAdmin: response.has_full_admin ?? false,
    };
}
